import { render } from "./WhoWeAre.vue?vue&type=template&id=90d77684&scoped=true"
import script from "./WhoWeAre.vue?vue&type=script&lang=js"
export * from "./WhoWeAre.vue?vue&type=script&lang=js"

import "./WhoWeAre.vue?vue&type=style&index=0&id=90d77684&scoped=true&lang=css"

import exportComponent from "/Users/edvinasjuck/PhpstormProjects/arunvilkasa.lt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90d77684"]])

export default __exports__